import classNames from "classnames";
import { useContext } from "react";
import { Link } from "react-router-dom";
import { NavItem } from "../types/types";
import { DataContext } from "./AppRouter";
import styles from "./MenuItem.module.css";

interface Props {
  item: NavItem;
  index: number;
  active: string | undefined;
  onClick: () => void;
}

const MenuItem = ({
  item: { to, icon, text, hasRight },
  index,
  active,
  onClick,
}: Props) => {
  const { permissions } = useContext(DataContext);

  if (hasRight && permissions && !hasRight(permissions.permission)) {
    return null;
  }

  return (
    <li key={index} className={styles["menu-item"]}>
      <Link
        to={to}
        onClick={onClick}
        className={classNames(styles["menu-link"], {
          [styles["menu-active"]]: String(to) === active,
        })}
      >
        {icon} {text}
      </Link>
    </li>
  );
};

export default MenuItem;
